<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand>
        <b-navbar-brand to="/">
          <img src="https://avatars0.githubusercontent.com/u/19179988" style="width:35px" alt="profile icon" />
        </b-navbar-brand>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item>Listening</b-nav-item>
          <b-nav-item>Reading</b-nav-item>
          <b-nav-item>Watching</b-nav-item>

          <b-nav-form @submit.prevent="submitSearchkey" class="mx-auto">
            <b-form-input
              size="sm"
              class="mr-2 w-75 w-sm-100"
              placeholder="输入关键字"
              v-model="searchKey"
            ></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0 mr-lg-2 w-10 w-sm-20" type="submit">搜索</b-button>
          </b-nav-form>

          <b-nav-form class="my-2 my-lg-0 mx-auto">
            <b-button
              size="sm"
              variant="outline-primary"
              class="text-white"
              to="/login"
              v-if="!isLogin"
            >登陆</b-button>
            <b-button
              size="sm"
              class="mr-2 text-white"
              variant="outline-primary"
              to="/admin"
              v-if="isLogin"
            >编辑</b-button>
            <b-button size="sm" variant="danger" @click.prevent="logout" v-if="isLogin">登出</b-button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      searchKey: ""
    };
  },
  computed: {
    ...mapState(["isLogin"])
  },
  watch: {
    searchKey: function() {
      if (!this.searchKey) {
        this.submitSearchkey();
      }
    }
  },
  methods: {
    submitSearchkey() {
      this.$store.dispatch("changeSearchKey", this.searchKey);
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        // 在路由守卫中通过 auth.onAuthStateChanged 监听用户登陆状态
        // 实现登出后自动跳转
        // this.$router.push({ name: "Login" });
      });
    }
  }
};
</script>